import { IconNames } from '@jobcost-monorepo/ui';
import { ROUTES } from './routes';
import { CardProps } from '@jobcost-monorepo/ui/molecules/SidebarLayout/SidebarMenuItem';

export const SIDEBAR_LINKS: CardProps[] = [
  { label: 'home', iconName: 'home', navigateTo: ROUTES.DASHBOARD },
  {
    label: 'quickInsert',
    iconName: 'resources',
    navigateTo: ROUTES.QUICK_INSERT,
    adminOnly: true,
  },
  {
    label: 'forecast',
    iconName: 'payment',
    navigateTo: ROUTES.PREVISIONALE,
    adminOnly: true,
  },
  {
    label: 'jobs',
    iconName: 'payment',
    adminOnly: true,
    subList: [
      {
        label: 'jobs',
        navigateTo: ROUTES.JOBS,
        adminOnly: true,
      },
      {
        label: 'orders',
        navigateTo: ROUTES.ORDERS,
        adminOnly: true,
      },
      {
        label: 'activities',
        navigateTo: ROUTES.ACTIVITIES,
        adminOnly: true,
      },
    ],
  },
  {
    label: 'registries',
    iconName: 'customer',
    adminOnly: true,
    subList: [
      {
        label: 'customers',
        navigateTo: ROUTES.CUSTOMERS,
        adminOnly: true,
      },
      {
        label: 'suppliers',
        navigateTo: ROUTES.SUPPLIERS,
        adminOnly: true,
      },
      {
        label: 'resources',
        navigateTo: ROUTES.RESOURCES,
        adminOnly: true,
      },
      {
        label: 'resourceSkills',
        navigateTo: ROUTES.RESOURCE_SKILLS,
        adminOnly: true,
      },
    ],
  },
  {
    label: 'purchases',
    iconName: 'payment',
    adminOnly: true,
    subList: [
      {
        label: 'purchasesInvoices',
        navigateTo: ROUTES.PURCHASE_INVOICE,
        adminOnly: true,
      },
    ],
  },
  {
    label: 'sales',
    iconName: 'payment',
    adminOnly: true,
    subList: [
      {
        label: 'salesInvoices',
        navigateTo: ROUTES.SALES_INVOICES,
        adminOnly: true,
      },
    ],
  },
  {
    label: 'timetable',
    iconName: 'payment',
    adminOnly: true,
    subList: [
      {
        label: 'deadlines',
        navigateTo: ROUTES.SCHEDULED_PAYMENTS,
        adminOnly: true,
      },
      {
        label: 'planning',
        navigateTo: ROUTES.SCHEDULED_VALUES,
        adminOnly: true,
      },
    ],
  },
  {
    label: 'analysis',
    iconName: 'file',
    adminOnly: true,
    subList: [
      {
        label: 'orders',
        navigateTo: ROUTES.ORDERS_SCHEDULED,
        adminOnly: true,
      },
      {
        label: 'finacialReport',
        navigateTo: ROUTES.FINANCIAL_REPORT,
        adminOnly: true,
      },
      {
        label: 'reportRs',
        navigateTo: ROUTES.REPORT_RS,
        adminOnly: true,
      },
    ],
  },
  {
    label: 'gestify',
    iconName: 'payment',
    adminOnly: true,
    subList: [
      {
        label: 'autofatture',
        navigateTo: ROUTES.AUTOFATTURE,
        adminOnly: true,
        feature: 'autofatture',
      },
      {
        label: 'gestifyCredentials',
        navigateTo: ROUTES.GESTIFY_CREDENTIALS,
        adminOnly: true,
        feature: 'gestifyCredentials',
      },
    ],
  },
  {
    label: 'settings',
    iconName: 'settings',
    adminOnly: true,
    subList: [
      {
        label: 'skills',
        navigateTo: ROUTES.SKILLS,
        adminOnly: true,
      },
      {
        label: 'typeOfPayments',
        navigateTo: ROUTES.TYPE_OF_PAYMENTS,
        adminOnly: true,
      },
      {
        label: 'users',
        navigateTo: ROUTES.USERS,
        adminOnly: true,
      },
      {
        label: 'orderCounters',
        navigateTo: ROUTES.ORDER_COUNTERS,
        adminOnly: true,
      },
    ],
  },
  {
    label: 'timesheet',
    iconName: 'timesheet',
    subList: [
      {
        label: 'timesheetSingle',
        navigateTo: ROUTES.TIMESHEET_SINGLE,
        adminOnly: false,
      },
      {
        label: 'timesheetReportGlobal',
        navigateTo: ROUTES.TIMESHEETS_REPORT_GLOBAL,
        adminOnly: true,
      },
    ],
  },
  ...(process.env.NODE_ENV === 'local'
    ? [
        {
          label: 'browseIcons',
          iconName: 'settings' as IconNames,
          navigateTo: ROUTES.BROWSE_ICONS,
          adminOnly: true,
        },
      ]
    : []),
];
